export default {
    bg: require('../assets/images/grope.beach.jpg'),
    sprites: [{
        image: require('../assets/images/grope.deer.png'),
        x: 5,
        y: 47,
        rot: -10,
        scale: 1,
    }, {
        image: require('../assets/images/grope.elephant.png'),
        x: 50,
        y: 55,
        rot: 0,
        scale: 1,
    }],
}